import { FormDropdownInputComponent } from 'src/features/generalForms/builder/types/DropdownInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useCallback } from 'react';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';

export const FormMultipleDropdownInput: FormDropdownInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const renderValue = useCallback(
    (arr: string[]) =>
      props.options
        ?.filter((opt) => arr?.includes(opt.key))
        .map((opt) => opt.value)
        .join(', ') ?? '',
    [props.options],
  );

  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <></>;
  }

  return <AnswerPreviewRow<string[]> value={value} renderValue={renderValue} {...props} />;
};
